import { useState } from 'react';
import { WEATHER_PARAM_CONFIG, WeatherParamKey } from '../data/demo';

export type WeatherThreshold = { lo: number; hi: number };
export type AllWeatherThresholds = Record<WeatherParamKey, WeatherThreshold>;

const KEY = 'weather_thresholds';

function getDefaults(): AllWeatherThresholds {
  const out = {} as AllWeatherThresholds;
  for (const p of WEATHER_PARAM_CONFIG) {
    out[p.key] = { lo: p.lo, hi: p.hi };
  }
  return out;
}

function load(): AllWeatherThresholds {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return getDefaults();
    return { ...getDefaults(), ...JSON.parse(raw) };
  } catch {
    return getDefaults();
  }
}

export function useWeatherThresholds() {
  const [thresholds, setThresholds] = useState<AllWeatherThresholds>(load);

  const save = (next: AllWeatherThresholds) => {
    localStorage.setItem(KEY, JSON.stringify(next));
    setThresholds(next);
  };

  const reset = () => {
    localStorage.removeItem(KEY);
    setThresholds(getDefaults());
  };

  return { thresholds, save, reset };
}
